import { isValidEmailAddress, fadeOutNotifications } from '../functions';
import Swal from 'sweetalert2'

$(document).ready(function() {

	const careersWidget = {
        isLoading: false,
        init() {
            $(document).on('click', '.career-btn-submit', this, this.send);
            $(document).on('change', '#career-auto_dealer', this, this.showJobs);
            $(document).on('click', '.career-file-btn', this, function() {
				$('#career-file').trigger('click');
			});
        },
		showJobs(event) {
			const _this = event.data;

			if($('#career-auto_dealer option:selected').val() == '') {
				$('#career-job').empty();
				return;
			}

			var jobs = $('#career-auto_dealer option:selected').data('jobs');

			$('#career-job').empty();
			$('#career-job').append($('<option></option>').attr('value', '').text("Alege job"));
			$.each(jobs, function(key, value) {
				$('#career-job').append($('<option></option>').attr('value', value.id).text(value.language.title));
			});
		},
		send(event) {
			const _this = event.data;

			if (_this.isLoading) {
                return false;
            }
		
			var errors = false;
			var errorsMsg = '';
			$('.careers-widget-from').find('.form-control').removeClass('is-invalid');
			$('.careers-widget-from').find('.form-check-input').removeClass('is-invalid');
			$('.careers-widget-from').find('.career-file-btn').removeClass('is-invalid');

			if ($('#career-name').val().trim() === '') {
				errors = true;
				$('#career-name').addClass('is-invalid');
			}
			if ($('#career-email').val().trim() === '') {
				errors = true;
				$('#career-email').addClass('is-invalid');
			}
			if (!_this.validateEmail($('#career-email').val().trim())) {
				errors = true;
				$('#career-email').addClass('is-invalid');
			}
			if ($('#career-phone').val().trim() === '') {
				errors = true;
				$('#career-phone').addClass('is-invalid');
			}
			if ($('#career-auto_dealer option:selected').val().trim() === '') {
				errors = true;
				$('#career-auto_dealer').addClass('is-invalid');
			}
			if ($('#career-job option:selected').val().trim() === '') {
				errors = true;
				$('#career-job').addClass('is-invalid');
			}
			if (!_this.validateCVFile($('#career-file').prop('files')[0])) {
				errors = true;
				errorsMsg = 'Doar fișierele PDF și DOCX sunt permise pentru CV.';
				$('.career-file-btn').addClass('is-invalid');
			}
			if (!$('#career-terms-and-condition').is(":checked")) {
				$('#career-terms-and-condition').addClass('is-invalid');
				errors = true;
			}

			if (errors) {
				var html = 'Va rugam completati campurile obligatorii!';
				if (errorsMsg != '') {
					html += '<br>'+errorsMsg;
				}
				Swal.fire({
					icon: 'error',
					title: 'Eroare!',
					html: html
				});
				return;
			}

			//Loading...
            _this.isLoading = true;
			let element = this;
			$(element).find('i').show();
		
			// Prepare form data
			var formData = new FormData();
			formData.append('module_id', $(element).data('mid'));
			formData.append('name', $('#career-name').val().trim());
			formData.append('email', $('#career-email').val().trim());
			formData.append('phone', $('#career-phone').val().trim());
			formData.append('auto_dealer', $('#career-auto_dealer option:selected').val().trim());
			formData.append('job', $('#career-job option:selected').val().trim());
			formData.append('file', $('#career-file').prop('files')[0]);
			formData.append('_token', $('meta[name="csrf-token"]').attr('content'));
			$.ajax({
				url: $(element).data('route'),
				type: 'POST',
				data: formData,
				processData: false,
				contentType: false,
				success: function(response) {
					_this.isLoading = false;
					$(element).find('i').hide();

					if (response.status == 0) {
                        var errorHtml = '';
                        for(var errorKey in response.errors) {
                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $('#career-' + errorKey).addClass('is-invalid');
                                //errorHtml += response.errors[errorKey][error] + '<br>';
                            }
                        }
						
						Swal.fire({
							icon: 'error',
							title: 'Eroare!',
							html: 'Va rugam completati campurile obligatorii!'
						});
                        return false;
                    }

					if (response.status == 1) {
						$('.careers-widget-from').find('.form-control').val('');
						$('.careers-widget-from').find('#career-auto_dealer option').prop('selected', false);;
						$('.careers-widget-from').find('#career-job option').prop('selected', false);;
						$('.careers-widget-from').find('#career-terms-and-condition').prop('checked', false);;

						Swal.fire({
							icon: 'success',
							title: 'Success!',
							html: formSuccessMessage
						});

						if (cookies_advertisement == 1) {
							//gtag('event', 'conversion', {'send_to': 'AW-732195211/z_5UCI7a8-cBEIvTkd0C'});
						}

						if (cookies_advertisement == 1 || cookies_social == 1) {
							//fbq('track', 'Lead');
						}

						return false;
					}

					Swal.fire({
						icon: 'error',
						title: 'Eroare!',
						html: response.message
					});
				},
				error: function(xhr, status, error) {
					_this.isLoading = false;
					$(element).find('i').hide();

					Swal.fire({
						icon: 'error',
						title: 'Eroare!',
						html: error
					});
				}
			});
		},
		validateEmail(email) {
			var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			return emailRegex.test(email);
		},
		validateCVFile(cvFile) {
			if (!cvFile) {
				return false;
			}

			var allowedExtensions = ['pdf', 'docx'];
			var extension = cvFile.name.split('.').pop().toLowerCase();

			return allowedExtensions.includes(extension);
		}
    };

    if ($('.careers-widget-from').length) {
        careersWidget.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/careers-widget.js